export default __webpack_public_path__ + "static/media/chambre.0812e16f.png";